"use client";

import styles from './index.module.scss';

export default function PriceBox({
    title = null,
    description = null,
    buttonText = "Inquire About Rates",
    onClick = null,
    type = "silver"
   }) {
    return (
        <div className={`${styles.box} ${styles[type]}`}>
            {title && <div className={styles.title}>{title}</div>}
            {description && <div className={styles.description}>{description}</div>}
            {buttonText && <button onClick={onClick}>{buttonText}</button>}
        </div>
    );
}